// Web module: parallel run. Custom page, not the generic entity list. Nav is not declared on the entities.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { appRoute } from '../../app/route-base'
import type { WebModule } from '../../lib/modules'
import { canSeeParallel } from './model'

export const parallelRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/parallel',
  component: lazyRouteComponent(() => import('./ParallelPage'), 'ParallelPage'),
})

export const module: WebModule = {
  routes: [parallelRoute],
  entityOverrides: {},
  nav: [
    {
      key: 'parallel',
      label: 'Parallel run',
      to: '/parallel',
      group: 'Settings',
      order: 45,
      visible: (viewer) => canSeeParallel(viewer.roles),
    },
  ],
}
